<svg:defs>
    <linearGradient
        id="paint6_linear_7217_69040"
        x1="57.9167"
        y1="69.4497"
        x2="57.9167"
        y2="419.57"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#1D53A4" />
        <stop
            offset="1"
            stop-color="#1D53A4"
            stop-opacity="0.33" />
    </linearGradient>
    <linearGradient
    id="paint8_linear_7217_69040"
    x1="116.122"
    y1="0.116699"
    x2="116.122"
    y2="139.051"
    gradientUnits="userSpaceOnUse">
    <stop stop-color="#D1E4FF" />
    <stop
        offset="1"
        stop-color="#B1CAF0" />
</linearGradient>

<linearGradient
id="paint9_linear_7217_69040"
x1="116.122"
y1="0.116699"
x2="116.122"
y2="139.051"
gradientUnits="userSpaceOnUse">
<stop
    stop-color="#1D53A4"
    stop-opacity="0.2" />
<stop
    offset="1"
    stop-color="#1D53A4" />
</linearGradient>
</svg:defs>
